@if(course()){
<div class="w-100 mb-0">
  <ng-content></ng-content>
  <nb-accordion multi class="nextsteps">
    <nb-accordion-item [collapsed]="collapsed">
      <nb-accordion-item-body class="p-0">
        <nb-list>
          @for (step of nextSteps(); track step.id) {
          <nb-list-item class="border-0 px-0">
            <nb-icon icon="square" class="float-start me-2"></nb-icon>
            <h3 class="mb-0">
              <a
                (click)="viewStep(course(), step)"
                class="pointer {{ color() }}"
                >{{ step.name }}</a
              >
            </h3>
          </nb-list-item>
          } @empty {
          <nb-list-item class="border-0 px-0">
            <p class="mb-0 {{ color() }}">
              Add next steps to your list by clicking on recommended action
              items throughout the program.
            </p>
          </nb-list-item>
          }
        </nb-list>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>
</div>
}
